export type SupplierDocumentType =
  | "bbbee_certificate"
  | "tax_clearance"
  | "vat_registration"
  | "company_registration"
  | "public_liability_insurance"
  | "workmens_comp"
  | "safety_file"
  | "rate_card"
  | "quote"
  | "reference_letter"
  | "contract"
  | "other";

export const SUPPLIER_DOCUMENT_TYPE_LABELS: Record<SupplierDocumentType, string> = {
  bbbee_certificate: "BBBEE certificate",
  tax_clearance: "Tax clearance",
  vat_registration: "VAT registration",
  company_registration: "Company registration",
  public_liability_insurance: "Public liability insurance",
  workmens_comp: "Workmen's comp / Letter of good standing",
  safety_file: "Safety file",
  rate_card: "Rate card",
  quote: "Quote",
  reference_letter: "Reference letter",
  contract: "Contract",
  other: "Other",
};

export const SUPPLIER_DOCUMENT_TYPE_GROUPS: {
  label: string;
  types: SupplierDocumentType[];
}[] = [
  {
    label: "Compliance",
    types: [
      "bbbee_certificate",
      "tax_clearance",
      "vat_registration",
      "company_registration",
      "public_liability_insurance",
      "workmens_comp",
      "safety_file",
    ],
  },
  {
    label: "General",
    types: ["rate_card", "quote", "reference_letter", "contract", "other"],
  },
];

export const ALL_SUPPLIER_DOCUMENT_TYPES: SupplierDocumentType[] =
  SUPPLIER_DOCUMENT_TYPE_GROUPS.flatMap((g) => g.types);

export type ExpiryStatus = "expired" | "expiring" | "valid";

export function getExpiryStatus(expiryDate: string | null | undefined): ExpiryStatus | null {
  if (!expiryDate) return null;
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const exp = new Date(expiryDate);
  exp.setHours(0, 0, 0, 0);
  const diffDays = Math.floor((exp.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  if (diffDays < 0) return "expired";
  if (diffDays <= 30) return "expiring";
  return "valid";
}

export const ACCEPTED_MIME_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/webp",
];
export const ACCEPTED_FILE_ACCEPT = ".pdf,.jpg,.jpeg,.png,.webp";
export const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024; // 20 MB

export const COMPLIANCE_DOCUMENT_TYPES: SupplierDocumentType[] =
  SUPPLIER_DOCUMENT_TYPE_GROUPS.find((g) => g.label === "Compliance")?.types ?? [];

export function sanitizeFileName(name: string): string {
  return name.replace(/[^a-zA-Z0-9._-]/g, "_").slice(0, 120);
}
